import { RetryLink } from "@apollo/client/link/retry";

// During a rolling deploy old and new pods serve side by side. A browser that
// loaded the new bundle can send a query naming a field the old pod's schema
// lacks, and gqlgen rejects it with 422 (parse/validation failure). gqlgen
// returns 422 only before dispatch, so nothing ran and a retry is safe even for
// mutations. Retrying for up to about a minute lands on a new pod once the
// rollout finishes. Used by every Apollo client (EMR, patient portal, visits).
export function isSchemaSkewError(error) {
  return error?.statusCode === 422;
}

export const rolloutRetryLink = new RetryLink({
  delay: { initial: 1000, max: 15000, jitter: true },
  attempts: { max: 8, retryIf: isSchemaSkewError },
});
